// Udziały procentowe w liczbach całkowitych, które sumują się DOKŁADNIE do 100 (metoda największej
// reszty). Zwykłe zaokrąglenie daje w legendzie np. 56 + 18 + 19 + 8 = 101%, co wygląda na błąd
// w danych. Kolejność wyniku = kolejność wejścia; same zera albo pusta lista dają zera.
export function percentShares(values) {
  const liczby = (values || []).map((v) => Math.max(0, Number(v) || 0));
  const suma = liczby.reduce((a, b) => a + b, 0);
  if (suma <= 0) return liczby.map(() => 0);
  const dokladne = liczby.map((v) => (v / suma) * 100);
  const wynik = dokladne.map(Math.floor);
  let brakuje = 100 - wynik.reduce((a, b) => a + b, 0);
  const wgReszty = dokladne
    .map((v, i) => ({ i, reszta: v - Math.floor(v) }))
    .sort((a, b) => b.reszta - a.reszta || a.i - b.i);
  for (let k = 0; brakuje > 0 && k < wgReszty.length; k += 1, brakuje -= 1) {
    wynik[wgReszty[k].i] += 1;
  }
  return wynik;
}
